module.exports = __webpack_public_path__ + "img/qmx.eccd7632.png";